'use strict';

/* eslint no-undef: "off" */
/**
 * footer wrapper
 */
define('footerWrapper',['lodash', 'buildTips', 'getCartApi', 'appStorage', 'GAReport'], function (_, buildTips, getCartApi, appStorage, GAReport) {
  return {
    template: '\n    <!--\n      <footer>\n        <div class="in-bottom-nav">\n          <div class="in-container">\n            <ul>\n              <li class="in-nav-item" v-for="item in navList">\n                <a :href="item.link" :title="item.name" :target=item.target @click="onTabBarItemClicked(item)">\n                  <!--\n                  <i :class="\'xp-iconfont xp-icon-\' + item.label"><span v-if="item.name == \'cart\' && count !==0 " v-text="count>9 ? \'\xB7\xB7\xB7\' : count "></span></i>\n                  -->\n                  <img :class="{\'cart-move\': !item.name }" :src="(mobileBottomBar[item.name || \'cart\'] || {}).logo_a || item.img" v-if="item.name !== pageId"/>\n                  <img :class="{\'cart-move\': !item.name }" :src="(mobileBottomBar[item.name || \'cart\'] || {}).logo_b || item.imgActive" v-if="item.name === pageId"/>\n                  <div v-if="!item.name && count !==0 " v-text="count>9 ? \'\xB7\xB7\xB7\' : count "></div>\n                  <p v-text="(mobileBottomBar[item.name] || {}).title || i18n[item.name]" :class="{\'active-text\': item.name === pageId}"></p>\n                </a>\n              </li>\n            </ul>\n          </div>\n        </div>\n\n        <build-tips></build-tips>\n      </footer>\n      -->\n    ',
    data: function data() {
      return {
        i18n: {
          home: 'HOME',
          category: 'CATEGORY',
          cart: 'CART',
          wsc: 'PINBOARD',
          bbs: 'XPARKers',
          user: 'ACCOUNT'
        },
        mobileBottomBar: {},
        navList: [{
          link: '/',
          name: 'home',
          label: 'tab-home',
          text: 'Home',
          img: require.toUrl('images/bottom_nav/home-before.svg'),
          imgActive: require.toUrl('images/bottom_nav/home-after.svg'),
          target: '_self'
        }, {
          link: '/category-list',
          name: 'category',
          label: 'tab-category',
          text: 'Category',
          img: require.toUrl('images/bottom_nav/category-before.svg'),
          imgActive: require.toUrl('images/bottom_nav/category-after.svg'),
          target: '_self'
        }, {
          link: '/checkout/cart',
          name: null,
          label: 'tab-cart',
          text: 'cart',
          img: require.toUrl('images/bottom_nav/cart-after.svg'),
          imgActive: require.toUrl('images/bottom_nav/cart-after.svg'),
          target: '_self'
        }, {
          link: window.commonDataJSON.bbs_forum_link,
          name: 'bbs',
          label: 'tab-bbs',
          text: 'bbs',
          img: require.toUrl('images/bottom_nav/BBS-before.svg'),
          imgActive: require.toUrl('images/bottom_nav/BBS-after.svg'),
          target: '_black'
        },
        // {
        //   link: '/wishlist',
        //   name: 'wsc',
        //   label: 'like',
        //   text: 'Pinboard'
        // },
        {
          link: window.localStorage.token ? '/customer/account' : window.commonDataJSON.login_url,
          name: 'user',
          label: 'tab-account',
          text: 'Account',
          img: require.toUrl('images/bottom_nav/account-before.svg'),
          imgActive: require.toUrl('images/bottom_nav/account-after.svg'),
          target: '_self'
        }],
        count: 0
      };
    },

    components: {
      buildTips: buildTips
    },
    props: {
      'pageId': {
        type: String,
        default: '',
        required: true
      }
    },
    mounted: function mounted() {
      this.searchKeyWords();
      getCartApi().then(this.flashCart.bind(this));
      appStorage.onChange('cart', this.flashCart.bind(this));
      this.mobileBottomBar = window.commonDataJSON.bottom_bar;
    },

    methods: {
      flashCart: function flashCart(aft) {
        if (aft) {
          this.count = aft.count;
        }
      },
      searchKeyWords: function searchKeyWords() {
        var search = window.location.search.slice(1);
        var searchArr = search && search.split('&').map(function (item) {
          return item.split('=');
        });
        var searchObj = _.fromPairs(searchArr);
        if (searchObj.q) {
          document.querySelector('[name="search"]').value = searchObj.q;
        }
      },
      onTabBarItemClicked: function onTabBarItemClicked(item) {
        if (item.label === "tab-cart") {
          new GAReport().customerClick({
            eventAction: 'TOP_CART_ENTRY',
            eventCategory: 'TOP_CART_#VERSION#'
          });
        } else if (item.label === "tab-account") {
          var action = window.localStorage.token ? "ACCOUNT" : "LOGIN";
          new GAReport().customerClick({
            eventAction: 'TOP_ENTRY_' + action,
            eventCategory: 'USER_#VERSION#'
          });
        }
      }
    }
  };
});
